import { any, arrayOf, bool, func } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import HELP_TEXTS from '../../campaigns/help-texts';
import { reactTableColumnShape } from '../../prop-types';
import withApiRequest from '../../REST/with-api-request';
import { tapFlashSuccess } from '../../utils/flash';
import getInfoTooltip from '../Tooltip/get-info-tooltip';
import { transformTableStateToSearchParams } from './utils';

function getSortedTableData(state) {
  return state.sortedData.map(ea => ea._original); // eslint-disable-line no-underscore-dangle
}

function TableDownloader({
  state,
  onDownload,
  columns,
  queryFn,
  onRequest,
  loading,
}) {
  async function getCurrentRowsData() {
    if (!state.manual) {
      return getSortedTableData(state);
    }

    const { filters, ...rest } = transformTableStateToSearchParams(
      state,
      columns,
    );

    return onRequest(queryFn, {
      search: { ...filters, ...rest },
    });
  }

  async function handleDownload() {
    const data = await getCurrentRowsData();
    const response = await onDownload(data);

    // Show the dynamic success message from dump function
    if (response && response.successMessage) {
      tapFlashSuccess(response.successMessage)();
    } else {
      tapFlashSuccess('Export completed successfully')();
    }

    return response;
  }

  return (
    <Button disabled={loading} onClick={handleDownload}>
      Download{' '}
      {getInfoTooltip(HELP_TEXTS, 'exportCampaigns', 'actionButtons', 'top')}
    </Button>
  );
}

TableDownloader.propTypes = {
  state: any.isRequired, // eslint-disable-line react/forbid-prop-types
  onDownload: func.isRequired,

  columns: arrayOf(reactTableColumnShape.isRequired).isRequired,
  queryFn: func,

  // HOC props
  loading: bool.isRequired,
  onRequest: func.isRequired,
};

TableDownloader.defaultProps = {
  queryFn: () => {},
};

export default withApiRequest({
  query: (fn, ...args) => fn(...args),
  error: 'flash',
})(TableDownloader);
